/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from "react";
import { GoSearch } from "react-icons/go";
import { MyContext } from "../../Context/MyProvider";
import axios from "axios";
import { GrLocation } from "react-icons/gr";
import { LuCalendar1 } from "react-icons/lu";
import Slider from "react-slick";
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import { showTost } from "../../showTost";
import Loading from "../../Loading";
import { useNavigate } from "react-router-dom";
import author1 from "../../Images/author-1.png";
import author2 from "../../Images/author-2.png";
import author3 from "../../Images/author-3.png";
import author4 from "../../Images/author-4.png";
import author5 from "../../Images/author-5.png";
import fireimg from "../../Images/fire.png";
import pinimg from "../../Images/pin.png";
import calendarimg from "../../Images/calendar.png";
import deadlineimg from "../../Images/deadline.png";
import { useTranslation } from "react-i18next";
import { formatMoney, getSiteCurrency } from "../../utils/money";
const NextArrow = ({ onClick }) => {
    return (
        <button className="custom-arrow next" onClick={onClick}>
            <FaArrowRightLong />
        </button>
    );
};

const PrevArrow = ({ onClick }) => {
    return (
        <button className="custom-arrow prev" onClick={onClick}>
            <FaArrowLeftLong />
        </button>
    );
};

const Dashboard = () => {

    const { t } = useTranslation();
    const { BaseUrl, setIsLoginShow } = useContext(MyContext);

    const [input, setInput] = useState();
    const [searchList, setSearchList] = useState([]);
    const [location, setLocation] = useState({ lat: null, long: null });
    const [apiRespData, setApiRespData] = useState();
    const [loading, setLoading] = useState(true);
    const [currency, setCurrency] = useState(getSiteCurrency());

    const navoigate = useNavigate();

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 8,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            { breakpoint: 1305, settings: { slidesToShow: 6, slidesToScroll: 1 }, },
            { breakpoint: 1030, settings: { slidesToShow: 5, slidesToScroll: 1 }, },
            { breakpoint: 770, settings: { slidesToShow: 4, slidesToScroll: 1 }, },
            { breakpoint: 580, settings: { slidesToShow: 2, slidesToScroll: 1 }, },
            { breakpoint: 430, settings: { slidesToShow: 2, slidesToScroll: 1 }, },
            { breakpoint: 325, settings: { slidesToShow: 1, slidesToScroll: 1 }, },
        ],
    };

    const settings2 = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            { breakpoint: 1240, settings: { slidesToShow: 3, slidesToScroll: 1 }, },
            { breakpoint: 1030, settings: { slidesToShow: 3, slidesToScroll: 1 }, },
            { breakpoint: 995, settings: { slidesToShow: 2, slidesToScroll: 1 }, },
            { breakpoint: 580, settings: { slidesToShow: 1, slidesToScroll: 1 }, },
        ],
    };

    const handleSearch = () => {
        const Userid = localStorage.getItem("Userid") || "0";
        if (Userid) {
            axios.post(
                `${BaseUrl}user_api/u_search_event.php`,
                {
                    uid: Userid,
                    keyword: input
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                .then((res) => {
                    setSearchList(res?.data?.SearchData);
                    // console.log(res);
                })
                .catch((err) => {
                    console.error('Error:', err.message);
                })
        }

    };

    useEffect(() => {
        if (!input) return;
        handleSearch();
    }, [input]);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLocation({
                        lat: position.coords.latitude,
                        long: position.coords.longitude,
                    });
                })
        }
    }, []);

    useEffect(() => {
        if (location?.lat && location?.long) {
            handleHome();
        }
    }, [location]);

    const handleHome = () => {
        const Userid = localStorage.getItem("Userid") || "0";

        if (Userid) {

            axios.post(
                `${BaseUrl}user_api/u_home_data.php`,
                {
                    uid: Userid,
                    lats: location?.lat,
                    longs: location?.long
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                .then((res) => {
                    console.log("u_home_data", res);
                    setLoading(false);
                    setApiRespData(res?.data?.HomeData);
                    localStorage.setItem("Tax", res.data.HomeData.Main_Data.tax);
                    localStorage.setItem("currency", res.data.HomeData.Main_Data.currency);
                    setCurrency(res.data.HomeData.Main_Data.currency);
                    localStorage.setItem("Wallet", res.data.HomeData.wallet);
                })
                .catch((err) => {
                    console.error('Error:', err.message);
                });
        }
    };

    const handleFavorite = (e, eventId) => {
        e.stopPropagation();

        const Userid = localStorage.getItem("Userid");
        if (Userid) {
            axios.post(
                `${BaseUrl}user_api/u_fav.php`,
                {
                    uid: Userid,
                    eid: eventId
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                .then((res) => {
                    console.log(res);
                    if (res?.data?.ResponseCode === '200') {
                        handleHome();
                    }
                    const toastType = res?.data?.ResponseCode === '200' ? 'success' : 'error';
                    showTost(res?.data?.ResponseMsg, toastType);
                })
                .catch((err) => {
                    console.error('Error:', err.message);
                });
        } else {
            setIsLoginShow(true);
        }
    }

    const handleNavigate = (index, item) => {
        if (index === 0) {
            navoigate("/event-details");
            sessionStorage.setItem("Eventid", item);
        } else {
            navoigate("/event-category", { state: { EventId: item.id, CoverImg: item.cover_img, Title: item.title } });
        }
    }

    return (
        <div>
            <div className="width_container">
                <div className="dashbord">
                    <div className="section_1">
                        <div className="box">
                            <h1 className="title">{t("Discover amazing event")}</h1>
                            <div className="input_box">
                                <GoSearch style={{ color: "white", fontSize: "20px" }} />
                                <input style={{ color: "white" }} value={input} onChange={(e) => setInput(e.target.value)} type="text" placeholder={t("Search here...")} />
                                {input && <div className="search_box overflow-hidden">
                                    {searchList.length >= 1
                                        ? searchList.map((item, index) => {
                                            return <div onClick={() => handleNavigate(0, item.event_id)} key={index} className="item_box">
                                                <img src={BaseUrl + item.event_img} alt="" />
                                                <div className="w-[100%] overflow-hidden">
                                                    <h4 className="font-bold whitespace-nowrap overflow-hidden overflow-ellipsis">{item.event_title}</h4>
                                                    <p className="max-_430_:whitespace-nowrap overflow-ellipsis"><GrLocation className="max-_430_:hidden" />{item.event_place_name}</p>
                                                    <p className="whitespace-nowrap overflow-ellipsis"><LuCalendar1 className="max-_430_:hidden" />{item.event_sdate}</p>
                                                </div>
                                            </div>
                                        })
                                        : <div className="h-[100%] w-[100%] flex items-center justify-center">
                                            <h1 className="font-bold">{t("Event Not Available !!")}</h1>
                                        </div>}
                                </div>}
                            </div>

                            <div className="review_box">
                                {!input && <div className="user_box">
                                    <img src={author1} alt="" style={{ zIndex: "40" }} />
                                    <img src={author2} alt="" style={{ zIndex: "30", marginLeft: "-10px" }} />
                                    <img src={author3} alt="" style={{ zIndex: "20", marginLeft: "-10px" }} />
                                    <img src={author4} alt="" style={{ zIndex: "10", marginLeft: "-10px" }} />
                                    <img src={author5} alt="" style={{ zIndex: "0", marginLeft: "-10px" }} />
                                </div>}
                                <div className="ms-[20px]">
                                    <p>⭐⭐⭐⭐⭐</p>
                                    <p style={{ color: "white", marginTop: "10px" }}>850+ {t("Reviews")}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="section_2">
                        <h1 className="title">{t("Browse by Category")}</h1>
                        <div className="category_box">
                            <div className="slider-container">
                                <Slider {...settings}>
                                    {apiRespData?.Catlist.map((item, index) => {
                                        return <div key={index} onClick={() => handleNavigate(1, item)} className="item_box">
                                            <div className="cat_img">
                                                <img src={BaseUrl + item.cat_img} width="60%" alt="" />
                                            </div>
                                            <h5 className="mt-[10px] text-[16px] font-bold">{item.title}</h5>
                                        </div>
                                    })}
                                </Slider>
                            </div>
                        </div>
                    </div>

                    <div className="section_3">
                        <div style={{ justifyContent: "space-between" }} className="flex_box">
                            <h1 className="title">{t("Latest Event")}</h1>
                            <div className="icon_box">
                                <img style={{ width: "20px", marginRight: "5px" }} src={fireimg} alt="FireImg" />
                                <h4 className="font-bold">{t("Just Dropped – Be the First to Book!")}</h4>
                            </div>
                        </div>
                        <div style={{ marginTop: "20px", flexWrap: "wrap" }} className="flex_box just_cent">
                            {apiRespData?.latest_event.map((item, index) => {
                                return <div onClick={() => handleNavigate(0, item.event_id)} key={index} className="card_box">
                                    <img src={BaseUrl + item.event_img} alt="" />
                                    <div className="detail_box">
                                        <div className="title">{item.event_title}</div>
                                        <div style={{ gap: "10px" }} className="flex_box">
                                            <LuCalendar1 style={{ fontSize: "30px" }} />
                                            <div className="">
                                                <p className="text-[15px]">{item.event_sdate}</p>
                                                <div className="flex items-center gap-[5px]">
                                                    <GrLocation />
                                                    <span className="text-[14px] overflow-hidden whitespace-nowrap overflow-ellipsis" >{item.event_place_name}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>

                    <div className="section_4">
                        <div style={{ justifyContent: "space-between" }} className="flex_box">
                            <h1 className="title">{t("Nearby Event")}</h1>
                            <div className="icon_box">
                                <img style={{ width: "20px", marginRight: "5px" }} src={pinimg} alt="FireImg" />
                                <h4 className="font-bold">{t("Happening Around You – Don’t Miss Out!")}</h4>
                            </div>
                        </div>
                        <div style={{ marginTop: "20px" }}>
                            <div style={{ margin: "0 10px" }} className="slider-container">
                                <Slider {...settings2}>
                                    {apiRespData?.nearby_event.map((item, index) => {
                                        return <div key={index} onClick={() => handleNavigate(0, item.event_id)} className="card_box">
                                            <div className="img_box">
                                                <img src={BaseUrl + item.event_img} className="w-[100%] h-[100%] object-cover" alt="" />
                                            </div>
                                            <div className="detail_box">
                                                <div style={{ justifyContent: "space-between", marginBottom: "10px" }} className="flex_box">
                                                    <div className="trim">
                                                        <span>{item.event_title}</span>
                                                        <p>{item.event_place_name}</p>
                                                    </div>
                                                    <div className="price_btn">{formatMoney(item.ticket_price, currency)}</div>
                                                </div>
                                                <p style={{ borderTop: "1px solid #f1f2f4", paddingTop: "10px", fontSize: "14px" }}>{item.event_sdate}</p>
                                            </div>
                                            <div style={{ justifyContent: "space-between" }} className="detail_box flex_box">
                                                <div className="flex_box">
                                                    <img src={BaseUrl + item.event_sponsore_img} alt="" />
                                                    <span className="font-[600]">{item.event_sponsore_title}</span>
                                                </div>
                                                <div onClick={(e) => handleFavorite(e, item.event_id)} className="">
                                                    {item.IS_BOOKMARK === 0
                                                        ? <svg fill="#191efc" width="30" height="30" viewBox="0 0 16 16">
                                                            <path d="M11 2.112c2.393 0 4.333 1.94 4.333 4.333 0 4.245-4.647 6.59-6.542 7.37-.511.21-1.071.21-1.582 0-1.896-.78-6.543-3.124-6.543-7.37 0-2.393 1.94-4.333 4.333-4.333a4.32 4.32 0 0 1 3 1.206 4.32 4.32 0 0 1 3-1.206zm0 1.333c-.807 0-1.537.317-2.077.835l-.462.443c-.258.248-.665.248-.923 0l-.462-.443c-.54-.518-1.27-.835-2.077-.835a3 3 0 0 0-3 3c0 1.588.86 2.9 2.101 3.978s2.728 1.794 3.615 2.159a.73.73 0 0 0 .567 0c.888-.365 2.373-1.08 3.615-2.159S14 8.034 14 6.445a3 3 0 0 0-3-3z"></path>
                                                        </svg>
                                                        : <svg fill="#191efc" width="30" height="30" viewBox="0 0 16 16">
                                                            <path d="M8 3.339a4.32 4.32 0 0 0-3-1.206c-2.393 0-4.333 1.94-4.333 4.333 0 4.246 4.647 6.59 6.543 7.37.511.21 1.071.21 1.582 0 1.896-.78 6.543-3.124 6.543-7.37 0-2.393-1.94-4.333-4.333-4.333a4.32 4.32 0 0 0-3 1.206z"></path>
                                                        </svg>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    })}
                                </Slider>
                            </div>
                        </div>
                    </div>

                    <div className="section_5">
                        <div style={{ justifyContent: "space-between" }} className="flex_box">
                            <h1 className="title">{t("Monthly Event")}</h1>
                            <div className="icon_box">
                                <img style={{ width: "20px", marginRight: "5px" }} src={calendarimg} alt="FireImg" />
                                <h4 className="font-bold">{t("This Month’s Top Picks – Plan Your Fun!")}</h4>
                            </div>
                        </div>
                        <div style={{ marginTop: "20px", flexWrap: "wrap" }} className="flex_box">
                            {apiRespData?.this_month_event.map((item, index) => {
                                return <div key={index} onClick={() => handleNavigate(0, item.event_id)} className="card_box">
                                    <div className="img_box">
                                        <img src={BaseUrl + item.event_img} className="w-[100%] h-[100%] object-cover" alt="" />
                                    </div>
                                    <div style={{ padding: "10px" }}>
                                        <div style={{ paddingBottom: "10px", lineHeight: "20px" }}>
                                            <h4 className="font-bold">{item.event_title}</h4>
                                            <p style={{ fontSize: "14px" }}>{item.event_place_name}</p>
                                            <span style={{ fontSize: "14px", color: "gray" }}>{item.event_sdate}</span>
                                        </div>
                                        <div style={{ borderTop: "1px solid #f1f2f4", paddingTop: "15px", cursor: "pointer", justifyContent: "space-between" }} className="flex_box">
                                            <div className="flex_box">
                                                <p style={{ fontSize: "14px", color: "gray" }}>{t("View Details")}</p>
                                                <FaArrowRightLong style={{ fontSize: "14px", color: "gray" }} />
                                            </div>
                                            <div onClick={(e) => handleFavorite(e, item.event_id)} className="">
                                                {item.IS_BOOKMARK === 0
                                                    ? <svg fill="#191efc" width="30" height="30" viewBox="0 0 16 16">
                                                        <path d="M11 2.112c2.393 0 4.333 1.94 4.333 4.333 0 4.245-4.647 6.59-6.542 7.37-.511.21-1.071.21-1.582 0-1.896-.78-6.543-3.124-6.543-7.37 0-2.393 1.94-4.333 4.333-4.333a4.32 4.32 0 0 1 3 1.206 4.32 4.32 0 0 1 3-1.206zm0 1.333c-.807 0-1.537.317-2.077.835l-.462.443c-.258.248-.665.248-.923 0l-.462-.443c-.54-.518-1.27-.835-2.077-.835a3 3 0 0 0-3 3c0 1.588.86 2.9 2.101 3.978s2.728 1.794 3.615 2.159a.73.73 0 0 0 .567 0c.888-.365 2.373-1.08 3.615-2.159S14 8.034 14 6.445a3 3 0 0 0-3-3z"></path>
                                                    </svg>
                                                    : <svg fill="#191efc" width="30" height="30" viewBox="0 0 16 16">
                                                        <path d="M8 3.339a4.32 4.32 0 0 0-3-1.206c-2.393 0-4.333 1.94-4.333 4.333 0 4.246 4.647 6.59 6.543 7.37.511.21 1.071.21 1.582 0 1.896-.78 6.543-3.124 6.543-7.37 0-2.393-1.94-4.333-4.333-4.333a4.32 4.32 0 0 0-3 1.206z"></path>
                                                    </svg>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>

                    <div className="section_6">
                        <div style={{ justifyContent: "space-between" }} className="flex_box">
                            <h1 className="title">{t("Upcoming Event")}</h1>
                            <div className="icon_box">
                                <img style={{ width: "20px", marginRight: "5px" }} src={deadlineimg} alt="FireImg" />
                                <h4 className="font-bold">{t("Coming Soon – Save Your Spot Early!")}</h4>
                            </div>
                        </div>
                        <div style={{ flexWrap: "wrap", marginTop: "20px" }} className="flex_box">
                            {apiRespData?.upcoming_event.map((item, index) => {
                                return <div key={index} onClick={() => handleNavigate(0, item.event_id)} className="card_box">
                                    <div div className="img_box" >
                                        <img src={BaseUrl + item.event_img} className="w-[100%] h-[100%] object-cover" alt="" />
                                    </div>
                                    <div style={{ padding: "10px" }}>
                                        <div className="">
                                            <div style={{ justifyContent: "space-between", marginBottom: "15px" }} className="flex_box">
                                                <div className="trim">
                                                    <span>{item.event_title}</span>
                                                    <p>{item.event_place_name}</p>
                                                </div>
                                                <div className="price_btn">{formatMoney(item.ticket_price, currency)}</div>
                                            </div>
                                            <div className="flex_box max-_580_:flex-nowrap max-_770_:flex-wrap max-_1025_:flex-nowrap max-_1305_:flex-wrap mb-[10px] justify-between">
                                                <h5 className="text-gray-500 text-[14px]">{item.event_sdate}</h5>
                                                <div className="detail_btn">{t("View Details")}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>

                </div>
            </div >

            {loading && <Loading />}

            {input && <div className="overlay" onClick={() => setInput("")}></div>}


        </div >
    )
}

export default Dashboard
/* jshint ignore:end */
